import { RootStore } from 'Portals/Customer/stores'

import { AccountCategoryTable } from './AccountCategoryTable'

export class AccountCategoryStore {
	table: AccountCategoryTable

	constructor(public rootStore: RootStore) {
		this.table = new AccountCategoryTable(rootStore)
	}
}
